import { BookCalendlyMeeting } from '../dashboard/pages/BookCalendlyMeeting/BookCalendlyMeeting';
import ConnectPages from '../dashboard/pages/SignupOnboarding/pages/1-ConnectPages/ConnectPages';
import { NewUserInfoFlow } from '../dashboard/pages/SignupOnboarding/pages/NewUserInfoFlow/NewUserInfoFlow';
import { InstallationPage } from '../dashboard/pages/XRayOnboarding/InstallationPage/InstallationPage';

const ONBOARDING = '/onboarding';

export const OnboardingRoutes = {
  connectPages: {
    path: `${ONBOARDING}/connect-page`,
    component: ConnectPages,
    getLink: () => `${ONBOARDING}/connect-page`,
  },
  userInfo: {
    path: `${ONBOARDING}/user-info`,
    component: NewUserInfoFlow,
    getLink: () => `${ONBOARDING}/user-info`,
  },
  installation: {
    path: `${ONBOARDING}/installation`,
    component: InstallationPage,
    getLink: () => `${ONBOARDING}/installation`,
  },
  bookDemo: {
    path: `${ONBOARDING}/book-demo`,
    component: BookCalendlyMeeting,
    getLink: () => `${ONBOARDING}/book-demo`,
  },
};
